import pdfIcon from '../../../../assets/svg/attachmentPdfIcon.svg';
import criticalColor from '../../../../assets/svg/criticalReportPrioIndicator.svg';
import highColor from '../../../../assets/svg/highReportPrioIndicator.svg';
import lowColor from '../../../../assets/svg/lowReportPrioIndicator.svg';
import mediumColor from '../../../../assets/svg/mediumReportPrioIndicator.svg';
import otherFileTypeIcon from '../../../../assets/svg/otherFileType.svg';
import videoIcon from '../../../../assets/svg/videoIcon.svg';
import { getCurrentIntl } from '../../../../i18n/intl/intl';

export const tabListNames = [
  { key: 'Attachment', name: 'Attachments' },
  { key: 'Messages', name: 'Messages' },
  { key: 'Processes', name: 'Processes' },
  { key: 'Notes', name: 'Notes' },
  { key: 'Audit Logs', name: 'Audit Logs' },
  { key: 'RFI', name: 'Request Information' },
  { key: 'Informed Individuals', name: 'Informed Individuals' },
];

export const getLocalizedTabName = (name: string) => {
  const intl = getCurrentIntl();
  const localized = {
    'Attachments': intl.formatMessage({ defaultMessage: 'Attachments' }),
    'Messages': intl.formatMessage({ defaultMessage: 'Messages' }),
    'Processes': intl.formatMessage({ defaultMessage: 'Processes' }),
    'Notes': intl.formatMessage({ defaultMessage: 'Notes' }),
    'Audit Logs': intl.formatMessage({ defaultMessage: 'Audit Logs' }),
    'Request Information': intl.formatMessage({ defaultMessage: 'Request Information' }),
    'Informed Individuals': intl.formatMessage({ defaultMessage: 'Informed Individuals' }),
  } as const;

  return localized[name as keyof typeof localized];
};

export const intlFormatRfiStatus = (label: string) => {
  const intl = getCurrentIntl();
  const intlLabels = [
    // Status Labels
    intl.formatMessage({ defaultMessage: 'Pending' }),
    intl.formatMessage({ defaultMessage: 'Responded' }),
    intl.formatMessage({ defaultMessage: 'Viewed' }),
    intl.formatMessage({ defaultMessage: 'Closed' }),
  ];

  const matchedLabel = intlLabels.find(intlLabel => intlLabel === label);

  return matchedLabel ?? label;
};

export function priorityOptionList() {
  const intl = getCurrentIntl();
  const priorityOptions: Array<{
    id: number;
    name: string;
    color: string;
  }> = [
      {
        id: 0,
        name: intl.formatMessage({ defaultMessage: 'Low' }),
        color: lowColor,
      },
      {
        id: 1,
        name: intl.formatMessage({ defaultMessage: 'Medium' }),
        color: mediumColor,
      },
      {
        id: 2,
        name: intl.formatMessage({ defaultMessage: 'High' }),
        color: highColor,
      },
      {
        id: 3,
        name: intl.formatMessage({ defaultMessage: 'Critical' }),
        color: criticalColor,
      },
    ];

  return priorityOptions;
}

// UPDATE `reportStatus` when adding/modifying statuses
export const getStatusOptions = () => {
  const intl = getCurrentIntl();
  const statusOptions = [
    {
      id: 0,
      name: intl.formatMessage({ defaultMessage: 'New Report' }),
    },
    {
      id: 1,
      name: intl.formatMessage({ defaultMessage: 'Under Review' }),
    },
    {
      id: 2,
      name: intl.formatMessage({
        defaultMessage: 'Pending further information',
      }),
    },
    {
      id: 3,
      name: intl.formatMessage({ defaultMessage: 'Closed' }),
    },
    {
      id: 5,
      name: intl.formatMessage({
        defaultMessage: 'Closed - Reporter Initiated',
      }),
    },
    {
      id: 6,
      name: intl.formatMessage({ defaultMessage: 'Archived' }),
    },
  ];
  return statusOptions;
};

export const REPORT_STATUS = {
  NEW_REPORT: 0,
  UNDER_REVIEW: 1,
  PENDING_FURTHER_INFORMATION: 2,
  CLOSED: 3,
  CLOSED_REPORTER_INITIATED: 5,
  ARCHIVED: 6,
} as const;

export const CLOSED_REPORTS_STATUS: Array<number> = [REPORT_STATUS.CLOSED, REPORT_STATUS.CLOSED_REPORTER_INITIATED, REPORT_STATUS.ARCHIVED];


export const PRE_DEFINED_ACTION_FIELD_NAMES = {
  'Due Date': 'DUE_DATE',
  Status: 'STATUS',
  Priority: 'PRIORITY',
  'Report Type': 'REPORT_TYPE',
  'Assigned Department': 'DEPARTMENT',
  Assignee: 'ASSIGNEE',
  'Subject Individual': 'SUBJECT_INDIVIDUAL',
  'Suspected Department': 'SUSPECTED_DEPARTMENT',
  Reporter: 'REPORTER',
  'Linked Report': 'LINKED_REPORT',
  Tags: 'TAGS',
  Followers: 'FOLLOWERS',
  'Loss Value': 'LOSS_VALUE',
  'Next Review': 'NEXT_REVIEW',
  // 'Report Outcome': 'REPORT_OUTCOME',
  // 'Employee Sanction': 'EMPLOYEE_SANCTION',
} as const;

export type ActionFieldType =
  (typeof PRE_DEFINED_ACTION_FIELD_NAMES)[keyof typeof PRE_DEFINED_ACTION_FIELD_NAMES];
export type ActionFieldTitleType = keyof typeof PRE_DEFINED_ACTION_FIELD_NAMES;

export const CUSTOM_ACTION_FIELD_TYPES = {
  TEXT_FIELD: 0,
  DATE_FIELD: 1,
  DROPDOWN_FIELD: 2,
} as const;

export type CustomActionFieldType =
  (typeof CUSTOM_ACTION_FIELD_TYPES)[keyof typeof CUSTOM_ACTION_FIELD_TYPES];


export const fieldTypes = {
  title: 2,
  descriptionText: 3,
  smallTextField: 0,
  bigTextField: 1,
  datePicker: 4,
  dropdown: 5,
  conclusionTitle: 6,
  conclusionText: 7,
};


//attachments 
export const MAX_FILE_SIZE = 26214400;
export const IS_ATTACHMENT = 0;
export const IS_RECORDING = 1;
export const CasemanagerAttachment = {
  MAX_FILE_SIZE: 1 * 1024 * 1024 * 1024, // 1 GB
  ALLOWED_EXTENSIONS: [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'pdf',
    'docx',
    'xlsx',
    'txt',
    'csv',
    'mp4',
    'mov',
    'ost',
    'pst',
  ],
};

export const VIDEO_FILE_TYPES = [
  'mp4',
  'm4a',
  'mkv',
  'mov',
  'm4v',
  'avi',
];

export const IMAGE_FILE_TYPES = [
  'jpg',
  'JPG',
  'png',
  'PNG',
  'jpeg',
  'JPEG',
  'svg',
  'heif',
];

export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/heif',
];

export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/x-m4v',
  'video/x-msvideo',
];

export const PDF_MIME_TYPE = ['application/pdf'];

export const DOC_MIME_TYPE = ['application/msword'];

export const DOC_FILE_TYPES = ['doc', 'docx'];

export const PDF_FILE_TYPE = ['pdf'];

export const getAttachmentIcon = (currfileType: string, url: string) => {
  if ([...IMAGE_FILE_TYPES, ...IMAGE_MIME_TYPES].includes(currfileType)) return url;
  if ([...VIDEO_FILE_TYPES, ...VIDEO_MIME_TYPES].includes(currfileType)) return videoIcon;
  if ([...DOC_FILE_TYPES, ...DOC_MIME_TYPE].includes(currfileType)) return otherFileTypeIcon;
  if ([...PDF_FILE_TYPE, ...PDF_MIME_TYPE].includes(currfileType)) return pdfIcon;

  return otherFileTypeIcon;
};

export const getFileTypeCategory = (fileType: string) => {
  if ([...IMAGE_FILE_TYPES, ...IMAGE_MIME_TYPES].includes(fileType)) return 'img';
  if ([...VIDEO_FILE_TYPES, ...VIDEO_MIME_TYPES].includes(fileType)) return 'video';
  if ([...PDF_FILE_TYPE, ...PDF_MIME_TYPE].includes(fileType)) return 'pdf';
  return 'document';
};

export const getFileExtension = (file: File) =>
  (file.name.split('.').at(-1) || file.type.split('/')[1]);